import React from 'react';

import classNames from 'classnames';

import * as classes from './style.module.scss';

export const Grid: React.FC = ({ children }) => {
  const length = React.Children.count(children);

  return (
    <div
      role="list"
      className={classNames(classes.root, { [classes.two]: length <= 2 })}
    >
      {children}
    </div>
  );
};
